import { Alert } from "@mui/material";

const AlertType = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  INFO: "info",
};

function Info({ message, infoType }) {
  return (
    <Alert sx={{ marginY: "1%" }} severity={infoType}>
      {message}
    </Alert>
  );
}

export { AlertType };
export default Info;
